import React, { Component } from "react";
import LayoutPublico from "../../componentes/Comunes/Layout/LayoutPublico";

class Error extends Component {
  render() {
    return (
      <LayoutPublico>
        <h1 className="h1 text-gray-900">Ocurrió un error</h1>
        {this.props.location.state.errores.map((error) => (
          <p className="lead text-gray-800" key={error}>
            • {error}
          </p>
        ))}
        <button
          className="btn btn-primary btn-icon-split text-center"
          onClick={this.props.history.goBack}
        >
          <span className="icon text-white-50">
            <i className="fas fa-arrow-alt-circle-left"></i>
          </span>
          <span className="text">Regresar</span>
        </button>
      </LayoutPublico>
    );
  }
}

export default Error;
